export const debugEvents = new EventTarget();

export interface ApiRequestMetrics {
  totalQuestionsCompared: number;
  successfulComparisons?: number;
  error?: boolean;
}

export interface ApiRequest {
  provider: 'openai' | 'groq';
  request: any;
  response?: any;
  error?: any;
  metrics?: ApiRequestMetrics;
}

export function logApiRequest(request: ApiRequest) {
  const event = new CustomEvent('api-request', {
    detail: {
      id: Math.random().toString(36).slice(2),
      timestamp: new Date().toISOString(),
      ...request
    }
  });
  debugEvents.dispatchEvent(event);
}